var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg07ControlCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_7-control-center_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "M18.6,3.9c-3.9-3.1-9.3-3.1-13.2,0c-0.2,0.2-0.2,0.5,0,0.7c1.1,1.1,2.2,2.2,3.3,3.3 C8.9,8.1,9.1,8.1,9.3,8C11,6.9,13,6.9,14.7,8c0.2,0.1,0.4,0.1,0.6-0.1c1.1-1.1,2.2-2.2,3.3-3.3c0.1-0.1,0.1-0.1,0.1-0.2 C18.8,4.3,18.8,4.1,18.6,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14.9,7C13,6,11,6,9.1,7C8.3,6.1,7.4,5.2,6.5,4.3c3.3-2.4,7.7-2.4,11,0C16.6,5.2,15.7,6.1,14.9,7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.1624,
    y1: 11.8703,
    x2: 7.7064,
    y2: 11.8703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M6.8,11.9c0,1.1,0.3,2.1,0.9,2.9l-3.3,3.3c-1.4-1.7-2.2-3.9-2.2-6.2c0-2.4,0.8-4.6,2.2-6.2 l3.3,3.3C7.1,9.8,6.8,10.8,6.8,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "M18.7,19.3c0-0.1-0.1-0.1-0.1-0.2c-1.1-1.1-2.2-2.2-3.3-3.3c-0.1-0.1-0.4-0.2-0.6-0.1 c-1.7,1.1-3.7,1.1-5.4,0c-0.2-0.1-0.4-0.1-0.6,0.1c-1.1,1.1-2.2,2.2-3.3,3.3c-0.2,0.2-0.2,0.5,0,0.7c3.9,3.1,9.3,3.1,13.2,0 C18.8,19.7,18.8,19.5,18.7,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M6.5,19.4c0.9-0.9,1.8-1.8,2.7-2.7c1.8,1,3.9,1,5.7,0c0.9,0.9,1.8,1.8,2.7,2.7 C14.2,21.8,9.8,21.8,6.5,19.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.2936,
    y1: 11.8727,
    x2: 21.8424,
    y2: 11.8727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M21.8,11.9c0,2.4-0.8,4.5-2.2,6.2l-3.3-3.3c0.6-0.8,0.9-1.8,0.9-2.9s-0.3-2.1-0.9-2.9 l3.3-3.3C21,7.3,21.8,9.5,21.8,11.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.4471,
    y1: 11.8728,
    x2: 14.5529,
    y2: 11.8728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 9.3,
    style: {
      fill: "url(#SVGID_3_)"
    },
    width: 5.1,
    height: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07ControlCenter);
export default __webpack_public_path__ + "static/media/07-control-center.f9e1dc86315795c8bcb5bf98c1df1418.svg";
export { ForwardRef as ReactComponent };